import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconTrash } from '@tabler/icons-react';
import { getErrorMessage } from '@common/utils';
import { toast } from 'react-toastify';
import { Button } from '@/components/ui/button';
import useTranslation from '@/hooks/useTranslation';
import { useMutationsDeleteUser } from '@/reactQuery/post';
import DeleteAccountModal from '../Modals/DeleteAccountModal';
import Routes from '@/router/routes';

function DeleteAccountForm() {
  const { lang } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsync: deleteUserAccount, isPending: isDeleting } = useMutationsDeleteUser();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDeleteAccount = async () => {
    try {
      await deleteUserAccount(null);
      setShowDeleteModal(false);
      navigate(Routes.accountDeleted.path);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      toast.error(errorMessage);
    }
  };

  return (
    <>
      <div className="mt-12">
        <h2 className="text-lg font-semibold text-red-600 pb-4">{lang.get('msg.deleteAccount')}</h2>
        <hr className="pb-6" />
        <p className="text-sm mb-3 text-light-gray">{lang.get('msg.deleteAccountDescription')}</p>
        <Button
          type="button"
          variant="destructive"
          onClick={() => setShowDeleteModal(true)}
          className="flex items-center"
        >
          <IconTrash className="w-4 h-4 mr-2" />
          {lang.get('msg.deleteYourAccount')}
        </Button>
      </div>

      {/* Delete Account Modal */}
      <DeleteAccountModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteAccount}
        isDeleting={isDeleting}
      />
    </>
  );
}

export default DeleteAccountForm;
